import IconSvg from "./IconSvg/IconSvg.vue"
import VImg from "./VImg.vue"
import VSkeleton from "./VSkeleton.vue"
import VSwitch from "./VSwitch.vue"
import VSwiper from "./VSwiper.vue"
import VNavigation from "./VNavigation.vue"
import GPTLoading from "./GPTLoading.vue"
import AppButton from "./AppButton.vue"
import BaseInput2 from "./BaseInput2.vue"
import { VButton } from "./Button"
import { VInput } from "./Input"

export default [
    IconSvg,
    VImg,
    VSkeleton,
    VSwitch,
    VInput,
    VSwiper,
    VNavigation,
    GPTLoading,
    VButton,
    AppButton,
    BaseInput2,
]
